export const VARCHAR_MAX_LENGTH = 255;
export const UUIDV4_LENGTH = 36;
